import {registerRoute as workbox_routing_registerRoute} from '/Users/paulobarcelos/Lab/Strawbees/code-ui/node_modules/workbox-routing/registerRoute.mjs';
import {NetworkFirst as workbox_strategies_NetworkFirst} from '/Users/paulobarcelos/Lab/Strawbees/code-ui/node_modules/workbox-strategies/NetworkFirst.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/Users/paulobarcelos/Lab/Strawbees/code-ui/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/Users/paulobarcelos/Lab/Strawbees/code-ui/node_modules/workbox-precaching/precacheAndRoute.mjs';
import {initialize as workbox_google_analytics_initialize} from '/Users/paulobarcelos/Lab/Strawbees/code-ui/node_modules/workbox-google-analytics/initialize.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "_next/static/chunks/14.62d4c9cbeaecee98caa8.js",
    "revision": "88a216544883bf977c6f97e1317b44e1"
  },
  {
    "url": "_next/static/chunks/16a7c4d089980d01729d01448a2350362254a2a2.355dc6fc3d31864398b8.js",
    "revision": "fa974ef564e76b2f8a25b8e7b5721e1a"
  },
  {
    "url": "_next/static/chunks/3ef630e34cd10ba68f9d468ac363ff81c534e1e9.2ddd678af72903b1b90f.js",
    "revision": "703626ff75f02a2240135f17ea90f9cb"
  },
  {
    "url": "_next/static/chunks/71247caf95475e3ea7f9a0f8a30beb258b23d005.62eea6234356ab335168.js",
    "revision": "9a12093cf4c54adc466d88b03e301368"
  },
  {
    "url": "_next/static/chunks/7f4fa054.40160db2f8e5f5f1f744.js",
    "revision": "179a4c5c3dd28ff8e26d6ec8964b5d7c"
  },
  {
    "url": "_next/static/chunks/8a28b14e.e3973de619494d1d02b0.js",
    "revision": "748d03bee0f4b824867ea73644df5657"
  },
  {
    "url": "_next/static/chunks/commons.32dd6a5937cd4c88086d.js",
    "revision": "a9a323bad67046eac04063fcc3645da6"
  },
  {
    "url": "_next/static/chunks/framework.6fff953eb0f638171baa.js",
    "revision": "9e5c77d379de3dcef5d4c66c69f76091"
  },
  {
    "url": "_next/static/chunks/main-59b18e2570b1f2390698.js",
    "revision": "3629944d608d75158bb019134bf5c5f4"
  },
  {
    "url": "_next/static/chunks/pages/_app-a148cc2130eb942fa123.js",
    "revision": "ed9ad26295b5bd45cbf2d4bb5c3152e4"
  },
  {
    "url": "_next/static/chunks/pages/_error-5550f08c092b5f58a9c9.js",
    "revision": "ffa3fe012c8c097aa8be463650e3be88"
  },
  {
    "url": "_next/static/chunks/pages/index-9c850e42e743220f6b62.js",
    "revision": "c1ecba1aa902f7685eb5a50f358df046"
  },
  {
    "url": "_next/static/chunks/pages/simulator-sandbox-396088f89aca41a234eb.js",
    "revision": "7e860cec81404d6d1d5b8b5975f899ee"
  },
  {
    "url": "_next/static/chunks/polyfills-feb8a7604fa7fce626b2.js",
    "revision": "beef7e19b8b9100e358d30fdf9fd78ff"
  },
  {
    "url": "_next/static/chunks/webpack-fca5e7c8573c106e61d6.js",
    "revision": "e616255e908382342ff4f24aec499c1b"
  },
  {
    "url": "_next/static/L6Dzgb98vF7a4f7WBUuXd/_buildManifest.js",
    "revision": "f622dd017575fc17481cbd3e588599e6"
  },
  {
    "url": "_next/static/L6Dzgb98vF7a4f7WBUuXd/_ssgManifest.js",
    "revision": "abee47769bf307639ace4945f9cfd4ff"
  },
  {
    "url": "block/index.html",
    "revision": "4ac3fbb12874a4089d3b6655e283b78f"
  },
  {
    "url": "confirm-email/index.html",
    "revision": "7f017e8f3467b527638b5ea1972ec404"
  },
  {
    "url": "cookie-policy/index.html",
    "revision": "4584b5be07a128787100001623f4429a"
  },
  {
    "url": "download/index.html",
    "revision": "6135c8721aedd8ebe61e985e8a9ddf0e"
  },
  {
    "url": "error/index.html",
    "revision": "007b0bd70fccccd0dd6a5074ebb8fbea"
  },
  {
    "url": "flow/index.html",
    "revision": "e7dd82721414de43c39a2a9468d87e9e"
  },
  {
    "url": "index.html",
    "revision": "2c6545f8ffe452fcd463062697dda248"
  },
  {
    "url": "ja/block/index.html",
    "revision": "3ac14f2012a658a870e7b2a06007476e"
  },
  {
    "url": "ja/confirm-email/index.html",
    "revision": "06412fdefa17345695567052a53940db"
  },
  {
    "url": "ja/cookie-policy/index.html",
    "revision": "d9e619a9d6a8cbc06f7b45d1d6ecbb14"
  },
  {
    "url": "ja/download/index.html",
    "revision": "562922df9d1e0ab7b3ed66d60e60c9dd"
  },
  {
    "url": "ja/error/index.html",
    "revision": "68108dc35dd2a81b67206b2e839c8bac"
  },
  {
    "url": "ja/flow/index.html",
    "revision": "698c3bdea104f35321b617ec9a5d3505"
  },
  {
    "url": "ja/index.html",
    "revision": "e8f2160af96e5c4c33a3928529f91261"
  },
  {
    "url": "ja/privacy-policy/index.html",
    "revision": "b17153cc210f100ed2b7266fdfbca4ca"
  },
  {
    "url": "ja/reset-password/index.html",
    "revision": "725534868de498ed3303f56e41fccdf9"
  },
  {
    "url": "ja/simulator-sandbox/index.html",
    "revision": "3ca4d104fd82f0280ce17dd0a89898f9"
  },
  {
    "url": "ja/terms/index.html",
    "revision": "8ff07cb888e6d566f74f220b86d78fab"
  },
  {
    "url": "ja/text/index.html",
    "revision": "6f394cd01546a7a2e86de59c42f0b87b"
  },
  {
    "url": "ja/user/index.html",
    "revision": "d86e6c8e471a7c9658f627f9209cf75c"
  },
  {
    "url": "privacy-policy/index.html",
    "revision": "335f86379a74894e89e3a59b53defc25"
  },
  {
    "url": "pt-br/block/index.html",
    "revision": "6e9ceab415f8a9cf3e9fe6878fa437e8"
  },
  {
    "url": "pt-br/confirmar-email/index.html",
    "revision": "b9988e4809f77e3cc3dc98b0154bb4e9"
  },
  {
    "url": "pt-br/cookies/index.html",
    "revision": "6b3541ebba507eec46b2988497c6d103"
  },
  {
    "url": "pt-br/download/index.html",
    "revision": "dca9439bbb0ac48e0acc65b443e8d74a"
  },
  {
    "url": "pt-br/erro/index.html",
    "revision": "7ffa505d74b45f23244baa230ebc0802"
  },
  {
    "url": "pt-br/flow/index.html",
    "revision": "74d47f290e66ae5f511df64f94f1626d"
  },
  {
    "url": "pt-br/index.html",
    "revision": "85ba029e467b52c6679b4f2e0e649452"
  },
  {
    "url": "pt-br/perfil/index.html",
    "revision": "be42a50cacff3f1f61a8a05ba5af435e"
  },
  {
    "url": "pt-br/privacidade/index.html",
    "revision": "e6756434e50f83bedc7982f1a483f006"
  },
  {
    "url": "pt-br/resetar-senha/index.html",
    "revision": "52802b1cdc749cb9f0f1492ae8fa4e41"
  },
  {
    "url": "pt-br/simulator-sandbox/index.html",
    "revision": "3d7413d85825dc0c3ad6125e08b8ecd0"
  },
  {
    "url": "pt-br/termos-de-uso/index.html",
    "revision": "2b2592534f678bc483a13f5d18268f62"
  },
  {
    "url": "pt-br/text/index.html",
    "revision": "00a286d9c9e9c68f20c5b93162f5130d"
  },
  {
    "url": "reset-password/index.html",
    "revision": "e7cdd0a7ca055ac93e5848797fbc8187"
  },
  {
    "url": "simulator-sandbox/index.html",
    "revision": "9af6dc082a0718739f85faf9aed3c98d"
  },
  {
    "url": "static/banners.json",
    "revision": "2bb60324776fed4ab2a1666fea6391dc"
  },
  {
    "url": "static/coding-cards/block-back-and-forth.png",
    "revision": "a25083fc8bb5202e69fb28c8a19b7d33"
  },
  {
    "url": "static/coding-cards/block-blink.png",
    "revision": "39e96ff9a7e4b8e46b484adf1a4de7b9"
  },
  {
    "url": "static/coding-cards/block-change-color-in-the-dark.png",
    "revision": "8e7a99b34c262b03791482b9661e9140"
  },
  {
    "url": "static/coding-cards/block-fading-colors.png",
    "revision": "faf15509a35c3cef764606e42cf7ef90"
  },
  {
    "url": "static/coding-cards/block-flicker.png",
    "revision": "2fd7e347adefee5155655feabae1c62a"
  },
  {
    "url": "static/coding-cards/block-flickering-color.png",
    "revision": "56ed3afeced4eec7d88f3fa33a1ef4e3"
  },
  {
    "url": "static/coding-cards/block-glow.png",
    "revision": "63aacdd2e36418794ccafe5c4558ae4b"
  },
  {
    "url": "static/coding-cards/block-laughter-generator.png",
    "revision": "6025cf250ab09377367a3f8e8d29ec38"
  },
  {
    "url": "static/coding-cards/block-light-switch.png",
    "revision": "329a0040b478df666a044f9a0522e71b"
  },
  {
    "url": "static/coding-cards/block-mood-light-switch.png",
    "revision": "3b458587151ef38e3e13c27f6ed62c0b"
  },
  {
    "url": "static/coding-cards/block-press-a-key-in-the-dark.png",
    "revision": "e993d4a4dd056d4716900b9df7ed10ce"
  },
  {
    "url": "static/coding-cards/block-shake-in-the-dark.png",
    "revision": "785a14ae24960438ac6908fde6455a81"
  },
  {
    "url": "static/coding-cards/block-shake.png",
    "revision": "e5d3aa031f17f1f1adeaf01dc3ea8871"
  },
  {
    "url": "static/coding-cards/block-shine-in-the-dark.png",
    "revision": "51803898b910cb044a9bd79dbd13f6dc"
  },
  {
    "url": "static/coding-cards/block-sweep.png",
    "revision": "9c7ab60ea5f16e194fd9e9686f04743d"
  },
  {
    "url": "static/coding-cards/block-switching-colors.png",
    "revision": "7c7b5643e4ffd2f0828883af7d4cb846"
  },
  {
    "url": "static/coding-cards/block-touch-and-trap.png",
    "revision": "07204a9171012d77ea3c5e4d9a2bf1ed"
  },
  {
    "url": "static/coding-cards/block-touch-and-wink.png",
    "revision": "c2e8ecad4e36b37e2836b6f046cd844f"
  },
  {
    "url": "static/coding-cards/block-touch-to-alternate-keys.png",
    "revision": "cec7cdeec6216515df02d278d0784c76"
  },
  {
    "url": "static/coding-cards/block-touch-to-change-color.png",
    "revision": "8e30ed623cdda0453d33349119250df3"
  },
  {
    "url": "static/coding-cards/block-touch-to-hold-position.png",
    "revision": "18ceb05314e0995ea4988a53ec18f012"
  },
  {
    "url": "static/coding-cards/block-touch-to-shine.png",
    "revision": "c7dffafc656d71d198c3fe49cf85fd01"
  },
  {
    "url": "static/coding-cards/block-touch-to-siren-light.png",
    "revision": "9842b97fe4432ad2e35aae58f5d1425c"
  },
  {
    "url": "static/coding-cards/block-touch-to-steer.png",
    "revision": "6fa31150f7fe63fc7f33d143b8cf2fa3"
  },
  {
    "url": "static/coding-cards/block-touch-to-switch-position.png",
    "revision": "e51b22a158a5544877041ba031d564cc"
  },
  {
    "url": "static/coding-cards/block-touch-to-write-a-word.png",
    "revision": "6e2d94af496f60708c0324fb944a6cde"
  },
  {
    "url": "static/coding-cards/block-type-a-key-over-and-over.png",
    "revision": "71267582bc0a68ded1a9399a6ad90bb5"
  },
  {
    "url": "static/coding-cards/block-type-a-sequence-of-letters.png",
    "revision": "081ec082862338ecdfecd1409d45272e"
  },
  {
    "url": "static/coding-cards/flow-advance-motor-position.png",
    "revision": "650e26a209bcebdd51cab3a2382c6de9"
  },
  {
    "url": "static/coding-cards/flow-back-and-forth.png",
    "revision": "c91efc6f1c9607121fce39e69353eec7"
  },
  {
    "url": "static/coding-cards/flow-blink-randomly-30percent-of-the-time.png",
    "revision": "d344938d03872317cd4b9bea9aefca76"
  },
  {
    "url": "static/coding-cards/flow-blink.png",
    "revision": "982acfaf727453020a6aabeb6815e797"
  },
  {
    "url": "static/coding-cards/flow-change-both-color-and-brightness.png",
    "revision": "293d3c007c60b5aa2f1eea4dfc6266ba"
  },
  {
    "url": "static/coding-cards/flow-change-fade-speed.png",
    "revision": "78c60301a0d2a6b8646da626637b587b"
  },
  {
    "url": "static/coding-cards/flow-change-movement-amplitude.png",
    "revision": "875d7a2064ffa5d825780416fa6f5c31"
  },
  {
    "url": "static/coding-cards/flow-circle-leds.png",
    "revision": "93ca509f6c28c2ea00d81dc9b3ceaabb"
  },
  {
    "url": "static/coding-cards/flow-complex-brightness-change.png",
    "revision": "72dff25df8420ead7f4ee3770fc68d29"
  },
  {
    "url": "static/coding-cards/flow-control-2-leds.png",
    "revision": "5b0ceeb871015f89082274d4e538a3a3"
  },
  {
    "url": "static/coding-cards/flow-control-motor-and-led.png",
    "revision": "749c3a219c02a1ee6b2675c72fbd155c"
  },
  {
    "url": "static/coding-cards/flow-double-oscillation.png",
    "revision": "8793f480dc91a126bbf49573d949bd1a"
  },
  {
    "url": "static/coding-cards/flow-flicker.png",
    "revision": "725a892d33934c9c90282bde16585def"
  },
  {
    "url": "static/coding-cards/flow-light-to-different-movements.png",
    "revision": "c27e35258233ddb912bac13a9d4a25bb"
  },
  {
    "url": "static/coding-cards/flow-move-and-blink-independently.png",
    "revision": "4bb9fa5a48e90bc759d1cbd5ec47acfb"
  },
  {
    "url": "static/coding-cards/flow-move-in-the-dark.png",
    "revision": "8d669c6f4dae193fe42dbed5972ae8f0"
  },
  {
    "url": "static/coding-cards/flow-move-randomly.png",
    "revision": "4a3f59a4ee308ca5ed49a5cc56623a73"
  },
  {
    "url": "static/coding-cards/flow-press-left-and-right-keys.png",
    "revision": "95f62369309d1e1951711d4424b0e0aa"
  },
  {
    "url": "static/coding-cards/flow-random-color.png",
    "revision": "f3b0e6ef2e95d1151aaa0336eabb3aa7"
  },
  {
    "url": "static/coding-cards/flow-shake.png",
    "revision": "830e17af7364a03f98029ee99db37e53"
  },
  {
    "url": "static/coding-cards/flow-shine-in-the-dark.png",
    "revision": "4f4850abc93b0ef26da18e5739b68ae2"
  },
  {
    "url": "static/coding-cards/flow-switch-fast-and-slow-movement.png",
    "revision": "5c258d7003de490ffb4cd8e6b4487de7"
  },
  {
    "url": "static/coding-cards/flow-switch-steady-and-random-light.png",
    "revision": "c84c4ee95bf421c6755c73070b90a79e"
  },
  {
    "url": "static/coding-cards/flow-switch-twinkle-eye.png",
    "revision": "a8d080e1ef69ff4755135764318da11c"
  },
  {
    "url": "static/coding-cards/flow-touch-light-switch.png",
    "revision": "35eca9805fb8a8c375a3982dcfb8d8ee"
  },
  {
    "url": "static/coding-cards/flow-touch-to-change-color-10-times.png",
    "revision": "b0995fe80d8bd41b96e0f4c97100fe90"
  },
  {
    "url": "static/coding-cards/flow-touch-to-light.png",
    "revision": "169e64a3c8d5b012b9f8b65056bdf1f8"
  },
  {
    "url": "static/coding-cards/flow-touch-to-move.png",
    "revision": "33eabf019896e73b8ce2c46253fdcf11"
  },
  {
    "url": "static/coding-cards/flow-touch-to-siren-light.png",
    "revision": "4c80090b264527cf9fe1e7fafe3f08f4"
  },
  {
    "url": "static/coding-cards/flow-touch-to-wave.png",
    "revision": "7bde7da15aa8c1b234f5323b7bd0c509"
  },
  {
    "url": "static/coding-cards/flow-touch-to-wink.png",
    "revision": "ead7756f36d0f8702454a23831933969"
  },
  {
    "url": "static/coding-cards/flow-trigger-movement-pattern.png",
    "revision": "bdde0cc38417f0ef57337c8e43dde324"
  },
  {
    "url": "static/coding-cards/flow-twinkle-for-4-seconds-at-startup.png",
    "revision": "4ca56b0286d2e0254831fa46d8285302"
  },
  {
    "url": "static/coding-cards/flow-type-key-over-and-over.png",
    "revision": "a710b87d5623b2f54bd6c20d0216fe89"
  },
  {
    "url": "static/coding-cards/flow-wave-quick-and-slow.png",
    "revision": "bc42db1244ace07f7eca52fc2cbfd0e4"
  },
  {
    "url": "static/coding-cards/flow-write-hello-in-one-second.png",
    "revision": "a8135593b485efa6f77410506e630dac"
  },
  {
    "url": "static/favicon/android-chrome-192x192.png",
    "revision": "56cf1c6c8b3f7285e504a0ca53f3ac73"
  },
  {
    "url": "static/favicon/android-chrome-512x512.png",
    "revision": "b84c9ad0740f6bd26278b5439610ddb7"
  },
  {
    "url": "static/favicon/apple-touch-icon.png",
    "revision": "4c0b1a3e8e359f78c1c2d330dfe5e07c"
  },
  {
    "url": "static/favicon/favicon-16x16.png",
    "revision": "f1f8d26f83b924a354cd39cfc6a620a5"
  },
  {
    "url": "static/favicon/favicon-32x32.png",
    "revision": "b05ce66663c464a36f9ae8bbaf9cb9de"
  },
  {
    "url": "static/favicon/mstile-150x150.png",
    "revision": "450b1ca48aa08c180be48548779423cf"
  },
  {
    "url": "static/favicon/safari-pinned-tab.svg",
    "revision": "1ddff683aa460cd8101bb5fec8002aae"
  },
  {
    "url": "static/fonts/BrandonText-Bold.woff2",
    "revision": "c64f9e145ea48d7c059da47973bda57e"
  },
  {
    "url": "static/fonts/BrandonText-Medium.woff2",
    "revision": "ac8f489be5c7d13cee7871310cf33bbe"
  },
  {
    "url": "static/fonts/BrandonText-Regular.woff2",
    "revision": "b62fe66f6451397244566704b34aa9e7"
  },
  {
    "url": "static/fonts/HI_SiYsKILxRpg3hIP6sJ7fM7PqlM-vWnsUnxlC9.woff2",
    "revision": "49804fde4dd67d7ec61332788721fb8a"
  },
  {
    "url": "static/fonts/HI_SiYsKILxRpg3hIP6sJ7fM7PqlPevWnsUnxg.woff2",
    "revision": "6fb84aff3e67a38612e50096bb116ad2"
  },
  {
    "url": "static/i18n/en.json",
    "revision": "200c1e1245b333d89f1a2ec43e55e84d"
  },
  {
    "url": "static/i18n/index.json",
    "revision": "23ad250b9ed1cd77ab0064f89c61a105"
  },
  {
    "url": "static/i18n/ja.json",
    "revision": "278d93368267e6f04c4c6a7dd53ad1a5"
  },
  {
    "url": "static/i18n/pt_BR.json",
    "revision": "24c036138e22dd190d7af75749c4189a"
  },
  {
    "url": "static/i18n/sv.json",
    "revision": "6f8b2221e410400258945fc1ea0504c0"
  },
  {
    "url": "static/i18n/zh-Hans-CN.json",
    "revision": "4886d0018255bc90ad2aff20ab015d26"
  },
  {
    "url": "static/lib/scratch-blocks/media/click.mp3",
    "revision": "f71910b391538a67231e088bba0d47eb"
  },
  {
    "url": "static/lib/scratch-blocks/media/comment-arrow-down.svg",
    "revision": "aadef3963f6809f568d1636b18db9fc9"
  },
  {
    "url": "static/lib/scratch-blocks/media/comment-arrow-up.svg",
    "revision": "042c1606da7d32266486aa8145ea8bf1"
  },
  {
    "url": "static/lib/scratch-blocks/media/delete-x.svg",
    "revision": "5a9a12bb1fe78336cae295c1746a82ce"
  },
  {
    "url": "static/lib/scratch-blocks/media/delete.mp3",
    "revision": "611d9f6a9392bb80d2000e143aa64323"
  },
  {
    "url": "static/lib/scratch-blocks/media/dropdown-arrow-dark.svg",
    "revision": "000650484bd9fc536153dc5d7d064996"
  },
  {
    "url": "static/lib/scratch-blocks/media/dropdown-arrow.svg",
    "revision": "be850da552699b8705b5902cb59c6d37"
  },
  {
    "url": "static/lib/scratch-blocks/media/eyedropper.svg",
    "revision": "ad88aac393c2d7d9e88f7229ac5bcdde"
  },
  {
    "url": "static/lib/scratch-blocks/media/green-flag.svg",
    "revision": "6a025d288965050155abca89738f6b10"
  },
  {
    "url": "static/lib/scratch-blocks/media/handclosed.cur",
    "revision": "6b45ea439228cba3afaa23022f1246a2"
  },
  {
    "url": "static/lib/scratch-blocks/media/handdelete.cur",
    "revision": "b0b4b0b44ed0136f7899c8b2957ca68f"
  },
  {
    "url": "static/lib/scratch-blocks/media/handopen.cur",
    "revision": "505cbb975d6102c374ec64aa92397051"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/arrow_button.svg",
    "revision": "af12c5eec2bd1f1e25d072869364cced"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/arrow.svg",
    "revision": "e349301923b796d8dd6b56b6203c5188"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/control_forever.svg",
    "revision": "11e7bf044cf13076eb1f9f63309017cc"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/control_repeat.svg",
    "revision": "35db6c180f639644f5bbd79d658eaf64"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/control_stop.svg",
    "revision": "0a513fecbaa8fb54d5d105d529f158c6"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/control_wait.svg",
    "revision": "55c2a2baaf2a4508b7d883a71e6606fe"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/event_broadcast_blue.svg",
    "revision": "66d4fdeb552c48adb936dd134f9a7cc3"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/event_broadcast_coral.svg",
    "revision": "1c866d5fc9b809e085f815d4cc528c3d"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/event_broadcast_green.svg",
    "revision": "07fc1baf5962aa6035c259dedfbdf10b"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/event_broadcast_magenta.svg",
    "revision": "4288ba3e3534c6c3bf065f888c74276a"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/event_broadcast_orange.svg",
    "revision": "fe7e38133cf1be78f504777da6864807"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/event_broadcast_purple.svg",
    "revision": "97e3a8d9596074ccb0f02f888e290920"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/event_when-broadcast-received_blue.svg",
    "revision": "a1c3ec8129337cdc6a0e00d51ba75b75"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/event_when-broadcast-received_coral.svg",
    "revision": "5cddf42acdb787c2cf03bdd5c3507e16"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/event_when-broadcast-received_green.svg",
    "revision": "7fdc28bcbc5bae41c0e55e8c1009bf6a"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/event_when-broadcast-received_magenta.svg",
    "revision": "1ada6afd03b601a82d0f7650f72b39b3"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/event_when-broadcast-received_orange.svg",
    "revision": "fcd47384fbb6dc6e136a6961b042bb0e"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/event_when-broadcast-received_purple.svg",
    "revision": "0da127529cc813e1f615b87cdcf87d28"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/event_whenflagclicked.svg",
    "revision": "b93d2d06ce25b6a10a8af6caac0890f3"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/remove.svg",
    "revision": "c9b4db61d6901dc5326d8af8f00eb770"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/set-led_blue.svg",
    "revision": "64e271cacd79c04f51e4140976ed69aa"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/set-led_coral.svg",
    "revision": "0f819c06f38eec93562e8a7e0390aa8d"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/set-led_green.svg",
    "revision": "95d552a2bf92aaf29ea7b7850efc1e78"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/set-led_magenta.svg",
    "revision": "bab1714e185b0cce2134c239d7f9dad4"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/set-led_mystery.svg",
    "revision": "7f11f033db1a2764ba822a9492113802"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/set-led_orange.svg",
    "revision": "8b9ac813216487a8c0ab20120d55e22c"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/set-led_purple.svg",
    "revision": "208edc4045ede72b45a4242e9237dde4"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/set-led_white.svg",
    "revision": "a8a2fcc4c60a3c2c4a093081568c2456"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/set-led_yellow.svg",
    "revision": "59a03bf890f2c2223b47faa092451e3c"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/wedo_motor-clockwise.svg",
    "revision": "4829ed554af2e113d3893e7ddfcacdec"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/wedo_motor-counterclockwise.svg",
    "revision": "ff174bda55c2cbd90fa98409845454eb"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/wedo_motor-speed_fast.svg",
    "revision": "c6ccc23958f6f1f63bf3da24397ce6d0"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/wedo_motor-speed_med.svg",
    "revision": "043ca7700cb3d77feb7c961e20902445"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/wedo_motor-speed_slow.svg",
    "revision": "5d36448f0913922583b23bbda55723f6"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/wedo_when-distance_close.svg",
    "revision": "a0a0a92846810f59ef052cea7335a80e"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/wedo_when-tilt-backward.svg",
    "revision": "9fbb87c4587ecaf99818cf2e32aa121c"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/wedo_when-tilt-forward.svg",
    "revision": "50ad4484043907a264ddd3d8959845c4"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/wedo_when-tilt-left.svg",
    "revision": "e37ddacb2f596649efccf371b6ea14af"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/wedo_when-tilt-right.svg",
    "revision": "1a3d9d81b6d8844a8a1442c4d2601861"
  },
  {
    "url": "static/lib/scratch-blocks/media/icons/wedo_when-tilt.svg",
    "revision": "eda90cb35927caf62a93effa8139cf1b"
  },
  {
    "url": "static/lib/scratch-blocks/media/repeat.svg",
    "revision": "faeda723162340d506d259eab15a57fc"
  },
  {
    "url": "static/lib/scratch-blocks/media/rotate-left.svg",
    "revision": "09b2fa9a323038e25e0d71f2e204c714"
  },
  {
    "url": "static/lib/scratch-blocks/media/rotate-right.svg",
    "revision": "68c6346a929214004666a69407245ce4"
  },
  {
    "url": "static/lib/scratch-blocks/media/sprites.png",
    "revision": "525a87801f9b33ec2cf606683aefed54"
  },
  {
    "url": "static/lib/scratch-blocks/media/sprites.svg",
    "revision": "911d25e52cb1d95f2d942ec5b7670d06"
  },
  {
    "url": "static/lib/scratch-blocks/media/status-not-ready.svg",
    "revision": "f78900031c49204a86c16c7bf733b88f"
  },
  {
    "url": "static/lib/scratch-blocks/media/status-ready.svg",
    "revision": "48ce534fd447c2be7e4e914640a29f01"
  },
  {
    "url": "static/lib/scratch-blocks/media/zoom-in.svg",
    "revision": "db8254dc60f8e2b5190a2f19440ddf74"
  },
  {
    "url": "static/lib/scratch-blocks/media/zoom-out.svg",
    "revision": "6dcc03cf4f57ffe8e5738cc0fc0ca731"
  },
  {
    "url": "static/lib/scratch-blocks/media/zoom-reset.svg",
    "revision": "c70243f271cbeec1c06acbff9d525dd5"
  },
  {
    "url": "static/lib/tree-sitter/tree-sitter.js",
    "revision": "ced2e17e95f1bde0fd36143ddedfd54c"
  },
  {
    "url": "static/og/block.png",
    "revision": "3d783bea9ab519f48bee08760b5e0db7"
  },
  {
    "url": "static/og/code.png",
    "revision": "2002fd0d63237e3e6fabd913dc7923cf"
  },
  {
    "url": "static/og/flow.png",
    "revision": "5ea84f4042060ca0a9d8b3ff99d54b1a"
  },
  {
    "url": "static/og/text.png",
    "revision": "4a0d323477519bd6b751cedb00f1c0ef"
  },
  {
    "url": "static/routes.json",
    "revision": "7ec62c96e18c4dee8b27413f0f3126d7"
  },
  {
    "url": "static/site.webmanifest",
    "revision": "8e4fe02b4207538b21d4750f7e77470b"
  },
  {
    "url": "sv/anvandare/index.html",
    "revision": "be48da59e04fd3e6dfcf91dab5805e19"
  },
  {
    "url": "sv/aterstall-losenord/index.html",
    "revision": "d2d336be4ac2e2888d6a46f66882ea90"
  },
  {
    "url": "sv/bekrafta-losenord/index.html",
    "revision": "267b237687a5b6bb8e82e5d005542b63"
  },
  {
    "url": "sv/block/index.html",
    "revision": "14e3200923f74c23d1aed6318aa5ee08"
  },
  {
    "url": "sv/cookiepolicy/index.html",
    "revision": "03261fa47142873533fb02d9ff74d280"
  },
  {
    "url": "sv/fel/index.html",
    "revision": "eb5c1927f318b696b83ed60ec3a46c93"
  },
  {
    "url": "sv/flow/index.html",
    "revision": "f4ceca5a758ffeaec68743885bbb9dd0"
  },
  {
    "url": "sv/index.html",
    "revision": "68f2e016c9c38424ba7a5a55f84e33f9"
  },
  {
    "url": "sv/integritetspolicy/index.html",
    "revision": "89caa728cb88fdf6be99d31acca22f63"
  },
  {
    "url": "sv/nedladdning/index.html",
    "revision": "ca57f150fba717e2e989ae7ed07dbb43"
  },
  {
    "url": "sv/simulator-sandbox/index.html",
    "revision": "ef06afdc2a877d7587942e31f4218def"
  },
  {
    "url": "sv/text/index.html",
    "revision": "706406ebcc445569ad89ff53bb0a5159"
  },
  {
    "url": "sv/villkor/index.html",
    "revision": "1a25e3fcd79d4d9340efae4148e1dc6e"
  },
  {
    "url": "terms/index.html",
    "revision": "14375d3588868c5141ba4acf0dc90c1a"
  },
  {
    "url": "text/index.html",
    "revision": "cca043c1f3b836e6866524f1a250a3f5"
  },
  {
    "url": "user/index.html",
    "revision": "b5d41c42ece5dbf33bea6d7cba31bc5f"
  },
  {
    "url": "zh-hans-cn/block/index.html",
    "revision": "8bcf2b54bb7d1d7e97af49969e79c728"
  },
  {
    "url": "zh-hans-cn/confirm-email/index.html",
    "revision": "ad7951b63fcba1dcc614c2f679376c7a"
  },
  {
    "url": "zh-hans-cn/cookie-policy/index.html",
    "revision": "cd1d94ca090f3b33d163be9277d0d286"
  },
  {
    "url": "zh-hans-cn/download/index.html",
    "revision": "00d750c017884bc243ffec899aa34fd5"
  },
  {
    "url": "zh-hans-cn/error/index.html",
    "revision": "c17020f9a5a506355c4da08eefba710e"
  },
  {
    "url": "zh-hans-cn/flow/index.html",
    "revision": "7f76ab294225940adca8bfc5abc3fac2"
  },
  {
    "url": "zh-hans-cn/index.html",
    "revision": "a176641fad91e4fa5607880db65ad200"
  },
  {
    "url": "zh-hans-cn/privacy-policy/index.html",
    "revision": "18ccf065dd276f7f2855dee8c5ee7132"
  },
  {
    "url": "zh-hans-cn/reset-password/index.html",
    "revision": "def51d3b72ff41d0a5b37d826bd6947e"
  },
  {
    "url": "zh-hans-cn/simulator-sandbox/index.html",
    "revision": "a1448cd5c281c05183d3b4014eda69fe"
  },
  {
    "url": "zh-hans-cn/terms/index.html",
    "revision": "5889656a884d6221b93fcb1d6dd7b4d7"
  },
  {
    "url": "zh-hans-cn/text/index.html",
    "revision": "509df13fbe1684cce0eeb927a5d20596"
  },
  {
    "url": "zh-hans-cn/user/index.html",
    "revision": "f67d8ab4c046fd82f40a99493c27494a"
  }
], {
  "directoryIndex": "index.html",
  "ignoreURLParametersMatching": [/./]
});




workbox_routing_registerRoute(/\/.*/, new workbox_strategies_NetworkFirst(), 'GET');


workbox_google_analytics_initialize({});

